// extracted by mini-css-extract-plugin
module.exports = {"container":"LatestOnWhaleCarousel_container__3LJJj","weeklyCalendar":"LatestOnWhaleCarousel_weeklyCalendar__7cwee"};